"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
exports.__esModule = true;
var styled_components_1 = __importStar(require("styled-components"));
var styled_system_1 = require("styled-system");
exports.error = function (props) {
    return props.error && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-color: ", ";\n\n    &:focus {\n      border-color: ", ";\n    }\n  "], ["\n    border-color: ", ";\n\n    &:focus {\n      border-color: ", ";\n    }\n  "])), props.theme.colors.red, props.theme.colors.red);
};
var FieldError = styled_components_1["default"].span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  width: 100%;\n\n  ", "\n  ", "\n  ", "\n  ", "\n"])), styled_system_1.space, styled_system_1.color, styled_system_1.fontSize, styled_system_1.lineHeight);
FieldError.displayName = 'FieldError';
// @ts-ignore
FieldError.isError = true;
FieldError.defaultProps = {
    pt: 1,
    pl: 1,
    color: 'red',
    fontSize: [0, 1],
    lineHeight: 'display'
};
exports["default"] = FieldError;
var templateObject_1, templateObject_2;
//# sourceMappingURL=FieldError.js.map